export default __webpack_public_path__ + "static/media/bq.082ccd6d.svg";